import { Module, VuexModule, Mutation, Action } from "vuex-module-decorators";
import Store from "../../index";
import { rawApi } from "@/lib/api";
import { WidgetResource, WidgetSettingResource, CreateWidgetSettingResource } from "@/models/api/system/widgets";

@Module({ name: "widget", dynamic: true, store: Store, namespaced: true })
export default class WidgetModule extends VuexModule {
  @Action
  async getWidgets() : Promise<WidgetResource[]> {
    const response = await rawApi.get<WidgetResource[]>(`/widget`);
    return response.data;
  }

  @Action
  async getWidgetSettings() : Promise<WidgetSettingResource[]> {
    const response = await rawApi.get<WidgetSettingResource[]>(`/widgetSettings`);
    return response.data;
  }
  
  @Action
  async createWidgetSetting(payload: CreateWidgetSettingResource) : Promise<WidgetSettingResource> {
    const response = await rawApi.post<WidgetSettingResource>(`/widgetSettings`, payload);
    return response.data;
  }

  @Action
  async updateWidgetSetting(payload: WidgetSettingResource) : Promise<WidgetSettingResource> {
    const response = await rawApi.put<WidgetSettingResource>(`/widgetSettings/${payload.id}`, payload);
    return response.data;
  }

  @Action
  async deleteWidgetSetting(id: number) : Promise<void> {
    await rawApi.delete(`/widgetSettings/${id}`);
  }
}